if (!window.Eurus) window.Eurus = { loadedScript: new Set() };

if (!window.Eurus.loadedScript.has('patchie-package-selector.js')) {
  window.Eurus.loadedScript.add('patchie-package-selector.js');

  function registerPatchieSelector() {
    Alpine.data('patchieSelector', (config) => ({
      mode: 'one-time',
      selectedTierIndex: 0,
      tiers: config.tiers || [],
      sectionId: config.sectionId,
      formId: config.formId,
      productId: config.productId,
      variantId: config.variantId,

      init() {
        const defaultIndex = Math.min(
          Math.max(parseInt(config.defaultTier ?? 0, 10), 0),
          this.tiers.length - 1,
        );
        this.selectedTierIndex = defaultIndex >= 0 ? defaultIndex : 0;
        this.$nextTick(() => this.syncFormFields());
        this.$watch('selectedTierIndex', () => this.syncFormFields());
        this.$watch('mode', () => this.syncFormFields());
      },

      get currentTier() {
        return this.tiers[this.selectedTierIndex] || {};
      },

      get selectedVariantId() {
        return this.variantId || '';
      },

      get selectedQuantity() {
        return this.currentTier.quantity || 1;
      },

      get selectedSellingPlanId() {
        if (this.mode !== 'subscribe') return '';
        return this.currentTier.sellingPlanId || '';
      },

      selectTier(index) {
        if (index < 0 || index >= this.tiers.length) return;
        this.selectedTierIndex = index;
      },

      syncFormFields() {
        const root = this.$root || this.$el;
        const idInput = root.querySelector('input[name="id"]');
        const qtyInput = root.querySelector('input[name="quantity"]');

        if (idInput) idInput.value = this.selectedVariantId;
        if (qtyInput) qtyInput.value = this.selectedQuantity;

        document.dispatchEvent(
          new CustomEvent(`eurus:product-page-variant-select:updated:${this.sectionId}`, {
            detail: {
              variantId: this.selectedVariantId,
              quantity: this.selectedQuantity,
              sellingPlanId: this.selectedSellingPlanId,
              mode: this.mode,
            },
          }),
        );
      },
    }));
  }

  function registerAndReinit() {
    registerPatchieSelector();

    // If elements were already in DOM before registration, Alpine errored on them.
    // Manually re-init any patchieSelector elements that don't have an Alpine data stack.
    document
      .querySelectorAll('[x-data*="patchieSelector"]')
      .forEach((el) => {
        if (!el._x_dataStack) {
          try { Alpine.initTree(el); } catch (e) { console.warn('patchieSelector re-init failed:', e); }
        }
      });
  }

  if (window.Alpine) {
    registerAndReinit();
  } else {
    document.addEventListener('alpine:init', registerAndReinit);
  }
}
